import {StructuredTableRow} from 'notebook/structured-tables/StructuredTableConstants';

import {RowData} from '../TableConstants';

function isStructuredTableRow(
  row: RowData | StructuredTableRow<unknown>
): row is StructuredTableRow<unknown> {
  const structuredTableRow = row as StructuredTableRow<unknown>;
  return (
    structuredTableRow.rowId !== undefined &&
    structuredTableRow.isFinalized !== undefined &&
    structuredTableRow.cells !== undefined
  );
}

export function isRowArchived(rowData?: RowData | StructuredTableRow<unknown> | null): boolean {
  if (rowData != null && isStructuredTableRow(rowData)) {
    return rowData.lastSyncedArchivePurpose != null;
  }

  return rowData?.uiData?.archivePurpose != null;
}
